import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { IntegrationSyncStatus } from "../../../types";
import { managementActions } from "../../action-creators";

export const getDynamicsStatusThunk =
    (hasLoading = true) =>
        async (
            dispatch: ThunkDispatchCommon,
            _getState: ThunkGetState,
            deps: ThunkDependencies,
        ): Promise<IntegrationSyncStatus> => {
            try {
                dispatch(managementActions.dynamics.getDynamicsStatusAsync.request(hasLoading));

                const response = await deps.si.api.management.getDynamicsStatus();
                dispatch(managementActions.dynamics.getDynamicsStatusAsync.success(response));

                return response.crmConnectionStatus.syncStatus;
            } catch (error) {
                dispatch(managementActions.dynamics.getDynamicsStatusAsync.failure(error));
            }
        };